
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

var TravelExpensePage = Vue.extend({})
Vue.component('travelExpense-page', TravelExpensePage)

export default {
  name: 'TravelExpensePage',
  directives: {
    TransferDom
  },
  components: {
    XTable,XButton,XInput,InlineXSwitch,XTextarea,XDialog
  },
  props: {
    saveStatus: Number
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: '08c4a7eccfdb4efa9ba2c8c12e8f81fa',//差旅报销
      operatorId: '',//当前 操作人
      refModule: '',
      refRecordId: '',
      stepId: '',
      info: {},
      togetherName: '',//同行人
      tripRemark: '',//出差事由
      name: '',//费用名称
      isDeduction: false,//是否用于抵扣费用报销(不计入成本)
      isDeductionVal: 0,//是否用于抵扣费用报销(不计入成本)
      remark: '',//备注
      fileObj: {},//上传附件集合
      fileShowList: [],//上传附件集合-预览
      uploadedFileIdList: [],//已上传附件ID集合
      oldRefRecordIds: '',//对应文件记录，明细ID字符串

      showToast: false,//弹窗-dialog
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl+'/wechat/expense/modExpense?flowId='+this.flowId+'&type=1',
      method: 'get'
    }).then((response) => {
      this.info = response.data.obj;
      this.refRecordId = response.data.refRecordId;
      this.refModule = response.data.refModule;
      this.operatorId = response.data.operatorId;
    }).catch((response) => {
      this.$vux.loading.hide();
    });
    this.$emit('sendTitleToParent','报销申请-差旅报销');
  },
  methods: {
    showMsg (msg) {
      this.$vux.alert.show({
        title: msg
      });
      setTimeout(() => {
        this.$vux.alert.hide();
      }, 2000)
    },
    openDialog (v) {// 打开选择业务-dialog
      this.showToast = true;
      console.log(v);
    },
    switchVal (data) {//switch
      if(data){
        this.isDeductionVal = 1;
      }else{
        this.isDeductionVal = 0;
      }
    },
    chooseFile () {// 选择附件
      let that = this;
      this.fileObj = document.getElementById('file').files;
      let fileL = document.getElementById('file').files.length;
      for(let i=0;i<fileL;i++){
        let file = document.getElementById('file').files[i];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload=function(e) {
          that.fileShowList.push(this.result);
        }
      }
      this.submitFile();
    },
    deleteFile (index) {// 删除已选附件
      this.fileShowList.splice(index,1);

      let deleteFileId = this.uploadedFileIdList[index];
      let fileData = new FormData();
      fileData.append("fileId",deleteFileId);

      this.axios({
        url: this.baseUrl+'/wechat/expense/deleteFile',
        method: 'post',
        data: fileData
      }).then((response) => {
        console.log('deleteFile',response);
        this.uploadedFileIdList.splice(index,1);
      }).catch((response) => {
        this.$vux.loading.hide();
      });

    },
    async submitFile () {// 上传附件-图片
      let fileObjL = this.fileObj.length;
      for(let i=0;i<fileObjL;i++){
        let fileData = new FormData();
        fileData.append("file",this.fileObj[i]);
        fileData.append("taskId",this.info.id);
        fileData.append("refRecordId",this.refRecordId);
        fileData.append("refModule",this.refModule);
        fileData.append("stepId",this.stepId);
        fileData.append("operatorId",this.operatorId);
        fileData.append("expenseType",this.info.type);
        fileData.append("flowId",this.flowId);

        let res = await this.axios({
          url: this.baseUrl+'/wechat/expense/uploadFile',
          method: 'post',
          data: fileData
        });
        this.uploadedFileIdList.push(res.data.fileId);
      }
    },
    saveForm () {//保存
      if(this.name == ''){
        this.showMsg('请补充必填信息');
        return false;
      }
      this.$vux.loading.show({
        text: '加载中'
      });
      let formData = new FormData();
      formData.append("flowId",this.info.flowId);
      formData.append("staffId",this.info.staffId);
      formData.append("id",this.info.id);
      formData.append("recCode",this.info.recCode);
      formData.append("name",this.name);
      formData.append("togetherName",this.togetherName);
      formData.append("tripRemark",this.tripRemark);
      formData.append("isDeduction",this.isDeductionVal);
      formData.append("remark",this.remark);
      formData.append("oldRefRecordIds",this.info.oldRefRecordIds);
      formData.append("type",this.info.type);

      this.axios({
        url: this.baseUrl+'/wechat/expense/saveForm',
        method: 'post',
        data: formData
      }).then((response) => {
        console.log('saveForm',response.data,this.saveStatus);
        if(response.data.status == 0){//保存失败
          this.$vux.loading.hide();
          this.showMsg(response.data.msg);
        }else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
          this.startFlow();
        }else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
          this.$emit('sendStatusToParent',{status:1});
          this.$vux.loading.hide();
        }

      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    startFlow () {//发起
      let startData = new FormData();
      startData.append("id",this.info.id);
      startData.append("flowId",this.info.flowId);
      startData.append("staffId",this.info.staffId);
      this.axios({
        url: this.baseUrl+'/wechat/expense/startFlow',
        method: 'post',
        data: startData
      }).then((response) => {
        console.log('startFlow',response.data);
        this.showMsg(response.data.msg);

        if(response.data.status == 1){

          this.$emit('sendStatusToParent',{
            status:0,
            id:response.data.taskId,
            stepId:response.data.stepId
          });
        }
        this.$vux.loading.hide();
      }).catch((response) => {
        this.$vux.loading.hide();
      });


    },
  }
}



// WEBPACK FOOTER //
// ./src/components/launch/finance/travelExpense.vue